import { useEffect, useMemo } from 'react';

import { LocalStore } from 'constants/localstore';
import { useAppDispatch, useAppSelector } from 'store/store-hooks';
import {
  EditorActions,
  setAddClipAction,
  setAddFileAction,
  setPlayAction,
} from 'components/app/editor/_mediator/editor-actions.slice';

export const useAppRestoreActions = () => {
  const appRestored = useAppSelector((state) => state.app.appRestored);
  const dispatch = useAppDispatch();

  const data = useMemo(() => {
    const json = localStorage.getItem(LocalStore.editorActions);
    if (json) return JSON.parse(json) as EditorActions;
  }, []);

  useEffect(() => {
    if (!appRestored || !data) return;
    const { playAction, addClipAction, addFileAction } = data;
    if (addClipAction) dispatch(setAddClipAction(addClipAction));
    if (addFileAction) dispatch(setAddFileAction(addFileAction));
    if (playAction) dispatch(setPlayAction(playAction));
  }, [appRestored]);
};
